import { useState } from "react";
import { useQueryWithSimpleErrorHandling } from "hooks";

export function useDictionaryHandling(DICTIONARY_QUERY, property, options = {}) {
  const { onCompleted, skip, ...restOptions } = options;
  const [dictionary, setDictionary] = useState([]);
  if (skip && dictionary.length > 0) {
    setDictionary([]);
  }
  const { loading } = useQueryWithSimpleErrorHandling(DICTIONARY_QUERY, {
    ...restOptions,
    skip,
    onCompleted: data => {
      const source = data ? data[property] : [];
      setDictionary(source);
      if (onCompleted) onCompleted();
    }
  });

  const getIdByName = name => {
    if (!name) return null;
    const id = dictionary?.find(z => z.name === name)?.id;
    return id;
  };

  const getIdByCode = code => {
    if (!code) return null;
    const id = dictionary?.find(z => z.code === code)?.id;
    return id;
  };

  const getCodeById = id => {
    if (!id) return null;
    const code = dictionary?.find(z => z.id === id)?.code;
    return code;
  };

  const getNameById = id => {
    if (!id) return null;
    const name = dictionary?.find(z => z.id === id)?.name;
    return name;
  };

  const getCodeByName = name => {
    if (!name) return null;
    const code = dictionary?.find(z => z.name === name)?.code;
    return code;
  };

  return { loading, dictionary, getIdByName, getIdByCode, getCodeById, getNameById, getCodeByName };
}
